import React from 'react';
import styled from "styled-components";
import * as media from "../../../media";
import CustomizedSwiper from '../../../basic/CustomizedSwiper'
import TranslateText from 'src/text/modal';
import CurrentLanguageContext from 'src/context/currentLanguageContext';

const Card = styled.div`
  padding: 30px;
  text-align: center;
  min-width: 265px;
  margin: 10px;
  ${media.biggerThan(900)`
    width: calc(25% - 20px);
    max-width: 650px;
    min-width: 265px;
    `
  }
`

export default function mobile() {
  return (
    <CurrentLanguageContext.Consumer>
      {currentLanguage => {
        let list = [];
        list.push((
          <Card>
            <div
              style={{
                fontSize: 60,
                color: '#173DB0',
              }}
            >
              50+
            </div>
            <div
              style={{
                fontSize: 16,
                color: 'rgba(0,0,0,0.75)',
                whiteSpace: 'normal',
                marginTop: 5,
              }}
            >
              <TranslateText id="main_info__mark_auto" place="bottom" />
            </div>
          </Card>
        ));

        list.push((
          <Card>
            <div
              style={{
                fontSize: 60,
                color: '#173DB0',
              }}
            >
              1000+
            </div>
            <div
              style={{
                fontSize: 16,
                color: 'rgba(0,0,0,0.75)',
                whiteSpace: 'normal',
                marginTop: 5,
              }}
            >
              <TranslateText id="mark_info__catalogue_items" place="bottom" />
            </div>
          </Card>
        ));

        list.push((
          <Card>
            <div
              style={{
                fontSize: 60,
                color: '#173DB0',
              }}
            >
              300+
            </div>
            <div
              style={{
                fontSize: 16,
                color: 'rgba(0,0,0,0.75)',
                whiteSpace: 'normal',
                marginTop: 5,
              }}
            >
              <TranslateText id="mark_info__dillers" place="bottom" />
            </div>
          </Card>
        ));

        list.push((
          <Card>
            <div
              style={{
                fontSize: 60,
                color: '#173DB0',
                whiteSpace: 'nowrap',
              }}
            >
              10 000+
            </div>
            <div
              style={{
                fontSize: 16,
                color: 'rgba(0,0,0,0.75)',
                whiteSpace: 'normal',
                marginTop: 5,
              }}
            >
              <TranslateText id="mark_info__sale_points" place="bottom" />
            </div>
          </Card>
        ));

        return currentLanguage === 'en' ? null : <CustomizedSwiper list={list} />;
      }}
    </CurrentLanguageContext.Consumer>
  )
}



// WEBPACK FOOTER //
// ./src/finwhale/common/princip/Mobile.js